module.exports = __webpack_public_path__ + "img/sisenor.b4c08a8f.jpg";